import { motion } from "framer-motion";
import { Package, Truck, ScanLine, ShieldCheck } from "lucide-react";

export function ShippingCard({ shipping }) {
  if (!shipping) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.15 }}
      data-testid="shipping-card"
      className="glass p-4 sm:p-6"
    >
      <div className="flex items-center gap-2 text-[10px] sm:text-[11px] uppercase tracking-[0.2em] font-mono-num text-[#F59E0B]">
        <Truck size={12} /> Smart Shipping &amp; Packaging
      </div>
      <h3 className="font-display text-lg sm:text-xl font-semibold text-white mt-1 mb-3 sm:mb-4">
        Ship it right the first time.
      </h3>
      <div className="grid sm:grid-cols-2 gap-3">
        <div className="p-3 sm:p-4 rounded-xl bg-white/[0.04] border border-white/[0.08]">
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-white/50 font-mono-num mb-1">
            <Package size={12} /> Recommended Packaging
          </div>
          <div className="text-white text-xs sm:text-sm font-medium">{shipping.packaging}</div>
          {shipping.weight_est && (
            <div className="text-white/50 text-[11px] sm:text-xs mt-1 font-mono-num">Est. weight: {shipping.weight_est}</div>
          )}
        </div>
        <div className="p-3 sm:p-4 rounded-xl bg-[#10B981]/[0.06] border border-[#10B981]/25">
          <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest text-[#10B981] font-mono-num mb-1">
            <Truck size={12} /> Best Carrier
          </div>
          <div className="text-white text-xs sm:text-sm font-medium">{shipping.carrier}</div>
          <div className="text-[#10B981] text-xs sm:text-sm mt-1 font-mono-num">{shipping.cost_range}</div>
        </div>
      </div>
    </motion.div>
  );
}

export function SerialCard({ ocr }) {
  if (!ocr || !ocr.extracted) return null;
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
      data-testid="serial-card"
      className="glass p-4 sm:p-6"
    >
      <div className="flex items-center gap-2 text-[10px] sm:text-[11px] uppercase tracking-[0.2em] font-mono-num text-[#6366F1]">
        <ScanLine size={12} /> Serial / Model OCR
      </div>
      <h3 className="font-display text-lg sm:text-xl font-semibold text-white mt-1 mb-3 sm:mb-4">
        Extracted from the tag / serial photo.
      </h3>
      <div className="p-3 sm:p-4 rounded-xl bg-black/40 border border-white/[0.06] font-mono-num text-white text-xs sm:text-sm break-words">
        {ocr.extracted}
      </div>
      {ocr.verification && (
        <div className="flex items-start gap-2 mt-3 text-[11px] sm:text-xs text-white/70">
          <ShieldCheck size={14} className="text-[#10B981] flex-shrink-0 mt-0.5" />
          <span>{ocr.verification}</span>
        </div>
      )}
    </motion.div>
  );
}
